export default {
  'SPEAKER' (state) {
    return state.speaker
  },
  'SPEAKERS' (state) {
    return state.speakers
  }
}
